<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat background="#ffffff" :current="2"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->

    <!-- 搜索框 -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>原料采购专区</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-search">
        <div class="content-search-box">
          <form class="custom-search-form" @submit.prevent="getSearchList">
            <input class="custom-search-input" type="text" v-model="keyword" placeholder="请输入CAS号、中文名称、英文名称"
              autocomplete="off" @input="clearKey" />
            <button class="custom-search-btn" type="submit">
              <svg class="search-icon" viewBox="0 0 24 24" width="20" height="20">
                <circle cx="11" cy="11" r="7" stroke="#fff" stroke-width="2" fill="none" />
                <line x1="18" y1="18" x2="15.5" y2="15.5" stroke="#fff" stroke-width="2" stroke-linecap="round" />
              </svg>
              搜索
            </button>
          </form>
        </div>
      </div>
      <div class="goods-box">
        <div class="goods-list" v-if="loading">
          <el-skeleton
            style="width: 316px;height: 310px;display: flex;flex-direction: column;justify-content: space-between;"
            v-for="i in 12" :key="i">
            <template slot="template">
              <el-skeleton-item variant="image" style="width: 100%; height: 150px;" />
              <div
                style="padding: 8px 0; display: flex;flex-direction: column;justify-content: space-between;height: 160px">
                <el-skeleton-item variant="p" style="width: 100%;height: 24px" />
                <div style="display: flex; align-items: center; justify-content: space-between;margin: 10px 0">
                  <el-skeleton-item variant="text" style="width: 30%;height: 20px" />
                  <el-skeleton-item variant="text" style="width: 30%;height: 20px" />
                  <el-skeleton-item variant="text" style="width: 30%;height: 20px" />
                </div>
                <el-skeleton-item variant="p" style="width: 100%;height: 20px" />
                <div style="display: flex; align-items: center; justify-content: space-between;margin: 10px 0">
                  <el-skeleton-item variant="text" style="width: 55%;height: 24px" />
                  <el-skeleton-item variant="text" style="width: 30%;height: 24px" />
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
        <div class="goods-list" v-else>
          <purchase-card v-for="(item, index) in goodsList" :key="index" :data="item" @show="showDong"></purchase-card>
        </div>
        <empty v-if="goodsList.length === 0"></empty>
        <el-pagination v-if="total > 20" class="pagination-box" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[20, 40, 60, 80]"
          :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 我要报价弹窗 -->
    <QuotationAdd :dialogVisible="dialogVisible" @refresh="getPurchaseList" @changeDialog="changeDialog"
      :row="selectInner">
    </QuotationAdd>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "../../components/public/home-top.vue";
import homeFooter from "../../components/public/home-footer.vue";
import navicat from "../../components/navicat/navicat.vue";
import topSearch from "../../components/public/top-search.vue";
import purchaseCard from "../../components/goods/purchase-card.vue";
import empty from "../../components/public/empty.vue";
import { online_purchase } from "@/api/modules/home";
import QuotationAdd from "../../components/addInfo/quotationAdd.vue";

export default {
  name: "purchase",
  components: { QuotationAdd, homeTop, homeFooter, navicat, topSearch, purchaseCard, empty },

  data() {
    return {
      dialogVisible: false,
      keyword: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      goodsList: [],
      loading: true,
      selectInner: {}
    };
  },
  created() {
    this.getPurchaseList();
  },
  methods: {
    changeDialog(e) {
      this.dialogVisible = e
    },
    showDong(e) {
      if (this.mixCheckLogin()) {

        this.selectInner = e
        this.dialogVisible = true
      }
    },
    clearKey(e) {
      if (e.target.value === '') {
        this.getPurchaseList();
      }

    },
    getSearchList() {
      if (this.keyword.trim() === '') {
        this.$message.warning({
          message: '请输入关键词',
          type: 'warning',
          duration: 2000,
          offset: 300,
        });
        return;
      }
      this.pageNum = 1;
      this.getPurchaseList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPurchaseList();
    },
    async handleCurrentChange(val) {
      this.pageNum = val;
      this.$refs.pageTopAnchor?.scrollIntoView({ behavior: 'auto', block: 'start' })
      await this.getPurchaseList();
    },
    async getPurchaseList() {
      this.loading = true;
      const res = await online_purchase({
        page: this.pageNum,
        limit: this.pageSize,
        keywords: this.keyword
      });
      this.total = res.data.data.total;
      this.goodsList = res.data.data.data;
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  // height: 287px;
  height: 265px;
}

.content {
  padding-bottom: 80px;
}

.bread-crumb {
  margin: 20px 0;
}

.content-search {
  margin: 20px 0 30px;

  .content-search-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.custom-search-form {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 2px 12px rgba(12, 96, 230, 0.08);
  padding: 4px 8px 4px 20px;
  border: 1.5px solid #e0e6ed;
  width: 420px;
  max-width: 100%;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.custom-search-form:focus-within {
  border-color: #409eff;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.12);
}

.custom-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  padding: 10px 0;
  color: #222;
}

.custom-search-input::placeholder {
  color: #bfcbd9;
  font-size: 15px;
}

.custom-search-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(90deg, #409eff 0%, #66b1ff 100%);
  color: #fff;
  border: none;
  border-radius: 24px;
  font-weight: 500;
  font-size: 16px;
  padding: 0 26px;
  height: 40px;
  margin-left: 12px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  transition: background 0.2s, box-shadow 0.2s;
}

.custom-search-btn:hover {
  background: linear-gradient(90deg, #307fd6 0%, #409eff 100%);
}

.search-icon {
  margin-right: 2px;
  vertical-align: middle;
}

.goods-box {
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  padding: 30px;
  box-sizing: border-box;

  .goods-list {
    display: flex;
    flex-wrap: wrap;
    gap: 27px 20px;
  }

  .pagination-box {
    text-align: right;
    margin-top: 68px;
    margin-left: 20%;
  }
}
</style>
